<template>
  <div
    id="page-container"
    class="enable-page-overlay side-scroll main-content-boxed position-relative"
  >
    <div
      id="page-loader"
      class="bg-gd-aqua"
      :class="loading ? 'show' : 'false'"
    ></div>
    <main id="main-container" v-if="notFound">
      <div class="hero bg-white-95">
        <div class="hero-inner">
          <div class="content content-full">
            <div class="px-3 py-5 text-center">
              <div
                class="row js-appear-enabled animated fadeIn"
                data-toggle="appear"
              >
                <div class="col-sm-6 text-center text-sm-right">
                  <div class="display-1 text-danger font-w700">404</div>
                </div>
                <div
                  class="col-sm-6 text-center d-sm-flex align-items-sm-center"
                >
                  <div class="display-1 text-muted font-w300">Error</div>
                </div>
              </div>
              <h1
                class="h2 font-w700 mt-5 mb-3 js-appear-enabled animated fadeInUp"
                data-toggle="appear"
                data-class="animated fadeInUp"
                data-timeout="300"
              >
                Oops.. You just found an error page..
              </h1>
              <h2
                class="h3 font-w400 text-muted mb-5 js-appear-enabled animated fadeInUp"
                data-toggle="appear"
                data-class="animated fadeInUp"
                data-timeout="450"
              >
                {{ notFoundErrorMessage }}
              </h2>
              <div
                class="js-appear-enabled animated fadeInUp"
                data-toggle="appear"
                data-class="animated fadeInUp"
                data-timeout="600"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </main>
    <main id="main-container" v-else>
      <div class="bg-light" v-if="this.showsuccess || this.success || this.formsuccess">
        <div class="hero">
          <div class="hero-inner">
            <div id="successMessage" class="content content-full text-center">
              <h2
                class="font-w300 text-muted mb-5 js-appear-enabled animated fadeInUp"
                data-toggle="appear"
                data-class="animated fadeInUp"
                data-timeout="400"
              >
                {{ translate[lang]["applicationsent"] }}
              </h2>
              <div
                class="js-appear-enabled animated fadeInUp"
                data-toggle="appear"
                data-class="animated fadeInUp"
                data-timeout="800"
              >
                <a
                  class="btn btn-hero-primary"
                  href="javascript:void(0)"
                  @click="reload()"
                >
                  <i class="fa fa-fw fa-arrow-right mr-1"></i>
                  {{ translate[lang]["newapplication"] }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content" v-else>
        <form id="formAction" @submit.prevent="sendForm" class="aanvraagstraatFormGtm">
          <div class="row">
            <div class="col-12" v-if="isCreated">
              <ActionForm
                :data="form.data"
                :initialVal="initialVal"
                isValidSubmit
                :isValidSubmittedData="false"
              ></ActionForm>
            </div>
          </div>
          <div class="row">
            <div class="col-12"></div>
          </div>
        </form>
      </div>
    </main>
  </div>
</template>  

<script>
import { mapActions, mapState } from "vuex";
import ActionForm from "../views/ActionForm";
import { PrefillMixin } from "./Mixins/PrefillMixin";

import { LanguageMixin } from "./Mixins/LanguageMixin";
import { SendFormMixin } from "./Mixins/SendFormMixin";
import { GetFormMixin } from "./Mixins/GetFormMixin";
export default {
  name: "Iframe",
  mixins: [PrefillMixin, LanguageMixin, GetFormMixin,SendFormMixin],
  components: {
    ActionForm
  },
  data() {
    return {
      //manipulate in mixins
      gtm: 'GTM-5M6H757',
      showsuccess: false,
      loading: false,
      error: false,
      success: false,
      notFound: false,
      notFoundErrorMessage: "",
      isCreated: false
    };
  },
  props: {
    initialVal: {
      type: Array,
      default: null
    },
    clientID: {
      type: String,
      default: ""
    }
  },
  async created() {
    await this.getTranslate();
    document.title = this.title;
    this.getFormById({
      id: this.$route.params.id,
      type: "noauth",
      isShow: false,
      isSubmitted: false
    }).then(response => {
      this.setLanguage();
      this.setSuccessOrError(response);
    });
    if (this.$route.query.bgcolor) {
      this.setBackgroundTransparent(this.$route.query.bgcolor);
    }
    if(this.$route.query.redirect) {
      this.form.data.redirect = this.$route.query.redirect;
    }

  },
  async mounted() {
    if (this.$route.query.gtm) {
      this.gtm = this.$route.query.gtm;
    }

    this.googleTagManager();
    document.body.appendChild(this.getGtmNoScript)
  },
  computed: {
    ...mapState({
      SubmitData: state => state.forms.SubmitData,
      formsuccess: state => state.forms.formsuccess,
      leadforced: state => state.forms.leadforced
    }),
    getGtmNoScript() {
      var noscriptObject = document.createElement('noscript');
      var noscript = "<iframe src='https://www.googletagmanager.com/ns.html?id=" + this.gtm + "' height='0' width='0' style='display:none;visibility:hidden'></iframe>";
      noscriptObject.innerHTML = noscript;
      return noscriptObject;
    },
    title() {
      //return 'ARXeditor | ' + this.translate[this.lang]["iframe_title"];
      return this.translate[this.lang]["iframe_title"];
    }
  },
  watch: {
    lang: function () {
      document.title = this.title;
    },
  },
  methods: {
    ...mapActions({
      getFormById: "forms/getFormById",
      getTranslate: "translate/getTranslate"
    }),
    setBackgroundTransparent(bgcolor) {
      this.$root.$emit("body-background-color", "#" + bgcolor);
    },
    onExpired() {},
    reload() {
      window.location.reload();
    },
    googleTagManager() {
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer',this.gtm);
    }
  }
};
</script>
<style>
.sweet-error {
  top: 5000px;
}
</style>
